<!--  登录   -->
<template>
  <div class="container">
    <div v-if="!elseAuthLogin" class="logo">
      <img class="tubiaoImg" :src="agency_logo" alt="">
      <!-- <img class="textImg" src="../../static/images/my_index/logo_text.png" alt=""> -->
      <p class="agency_name">{{ agency_name }}</p>
    </div>
    <div class="foot">
      <!-- <div v-if="canShowMp" class="wx_btn" @click="goWx">
        <img src="https://newoss.zhulong.com/forum/202303/07/15/1678174197449890.png" alt="">微信登录
      </div> -->
      <div v-if="mobile_login" class="wx_btn" @click="account_login(2)">
        验证码登录
      </div>
      <!-- <div v-if="canShowMp" class="other">
        <span class="mima" @click="account_login(1)">密码登录</span>
        <span class="line">|</span>
        <span class="yzm" @click="account_login(2)">验证码登录</span>
      </div> -->
      <div v-if="username_login" class="other" style="justifyContent:center;">
        <span class="mima" @click="account_login(1)">密码登录</span>
      </div>
      <div v-if="!elseAuthLogin" class="xy" @click="agreeClick">
        <img v-if="!agree" class="icon_gray" src="https://newoss.zhulong.com/forum/202303/07/16/1678176277865852.png" alt="">
        <img v-else class="icon_red" src="https://newoss.zhulong.com/forum/202303/07/16/1678176281454572.png" alt="">
        <p>我已阅读并同意<span style="text-decoration: underline;" @click.stop="toProtocol()">《用户协议》</span></p>
      </div>
      <van-dialog v-model="dialogShow" :show-confirm-button="false" :show-cancel-button="false" class="dialog" cancel-button-text="不同意" confirm-button-text="同意" title="温馨提示" @confirm="confirmClick()" @cancel="cancelDialog()">
        <div class="read">请阅读并同意<span @click="toProtocol()">《用户协议》</span></div>
        <div class="btns">
          <div @click="cancelDialog">不同意</div>
          <div @click="confirmClick">同意</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { Dialog } from 'vant'
import { Toast } from 'vant'
import { getMiniUrlLink, getSetting, getAgencyInfo } from '@/api/login'
import { canShowForMp } from '@/api/my_user.js'
import WechatState from '@/utils/isWechatState.js'
import wxsdk from 'weixin-js-sdk'
import tool from '@/utils/tools.js'
import { ischeckBind, getSnsUserInfo } from "@/api/login.js"

export default {
  data() {
    return {
      dialogShow: false,
      agree: sessionStorage.getItem('agree') || false,
      redirect: '',
      wx_url: '', // 跳转微信小程序链接
      pre_type: '',
      // true 不是小程序审核期间 可以展示微信登录，false 小程序审核期间，不展示微信登录
      canShowMp: false,
      code_login:0,
      mobile_login:0,
      username_login:0,
      agency_logo:'',
      agency_name:'',
      elseAuthLogin: false, // 其他机构授权登录Eg：390
      // 微信公众号
      authGzhId: 'wxf3117cecab674509',
      auth_code: '', // 微信授权code
      openid: '', // 通过后台交换code获取openid
      unionid: '', // 通过后台交换code获取unionid
      headimgurl: '', // 通过后台交换code获取 headimgurl
      nickname: '', // 通过后台交换code获取 nickname
      sex: '' // 通过后台交换code获取 sex
    }
  },
  created() {
    // 页面初始化
    this.initPageConfig()
  },
  methods: {
    // 页面初始化
    initPageConfig() {
      // 判断机构id，特殊处理
      const is_390 = tool.checkLocationAgencyId('390')
      if (is_390) {
        this.elseAuthLogin = true
        var toast = 'is 390 '
        const fromapp = Cookies.get('fromapp') || ''
        toast += ' fromapp = ' + fromapp
        if (fromapp == 1) {
          toast += ', app 内执行登录'
          // alert(toast)
          // 特殊机构390，APP 嵌入 h5 得操作 ： 去指定链接登录
          const redirect = 'https://s390.1py.com.cn/ucenter/prod-api/api/user/dxCallback?appstate=Dh' + Date.now()
          const logurl = 'bridge:/base/uniCertiAuthorizeCode/pageInit?openType=refresh&clientId=1913688521&redirectUri=' + encodeURIComponent(redirect)
          window.location.href = logurl
        } else {
          toast += ', h5 执行pc 登录'
          // alert(toast)
          // 特殊机构390，非APP嵌入，按pc的流程 ：去指定链接登录
          const logurl = 'https://s390.1py.com.cn/ucenter/prod-api/api/user/dxOauth'
          window.location.href = logurl
        }
      } else {
        /**
         * ⭐️⭐️⭐️  非特殊指定的机构，正常代码流程  ⭐️⭐️⭐️
         * 后续修改代码的，先考虑做什么需求，再改代码
         * 找准改代码的位置和不同环境
         * 不同环境执行不同代码，故目前删除了mounted()的方法，集中到一起
         */
        // 获取重定向地址
        this.redirect = this.$route.query.redirect || window.location.origin
        /// 检测是否是小程序里的h5
        if (WechatState.isWechatMiniprogram) {
          this.wxMiniLogin()
        } else {

          // 不是微信h5环境、不是小程序的普通情况
          this.getLoginSetting()
          this.getAgencyInfoFun()

          // 小程序之外的 登录流程
          if (this.checkWechatH5() && Cookies.get('agency_id') == 2) {
            // 微信浏览器下
            this.wechatH5Auth = true
            if (this.$route.query.auth_openid && this.$route.query.auth_unionid && this.$route.query.auth_state) {
              // 授权过的，不处理
              this.openid = this.$route.query.auth_openid
              this.unionid = this.$route.query.auth_unionid
              this.nickname = decodeURIComponent(this.$route.query.auth_nickname || '')|| ''
              this.headimgurl = this.$route.query.auth_headimgurl || ''
            } else {
              this.showAuthBind()
            }
          }
        }
      }
    },
    // 判断是微信h5环境
    checkWechatH5() {
      const isWxH5 = WechatState.isWechat && !WechatState.isWechatMiniprogram && !WechatState.wxwork
      return isWxH5
    },
    // 微信js授权绑定
    showAuthBind() {
      // 回调之后回到之前的页面
      var redirect = window.location.href
      redirect = encodeURIComponent(redirect)
      const origin = 'https://m.zhulong.com'// 去筑龙授权
      var auth_redirect = `${origin}/ucenter/wechatAuthResult?jump_redirect=${redirect}`// 微信授权回调页面
      console.log(auth_redirect, 'auth_redirect')
      auth_redirect = encodeURIComponent(auth_redirect)
      const appid = this.authGzhId
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${auth_redirect}&response_type=code&scope=snsapi_userinfo&state=success#wechat_redirect`
      window.location.href = url
    },
    // 去小程序的登录
    wxMiniLogin() {
      if (WechatState.isWechatMiniprogram) {
        console.log('去小程序登录');
        var url = `/pages/login/login?xcx_out=true`
        wxsdk.miniProgram.redirectTo({
          url: url
        })
      }
    },
    // 获取机构名称
    getAgencyInfoFun() {
      getAgencyInfo().then(res => {
        if (res.errNo == 0) {
          const result = res.result || {}
          this.agency_logo = res.result.icon_url
          this.agency_name = res.result.short_name
          Cookies.set('agency_id',res.result.agency_id)
          // this.sig_logo = result.thumb
          // this.qr_logo = result.icon_url
        }
      })
    },
    // 获取登录方式配置
    getLoginSetting(){
      getSetting().then((res)=>{
        if(res.errNo==0){
          this.code_login=res.result.code_login
          this.mobile_login=res.result.mobile_login
          this.username_login=res.result.username_login
          // 如果只设置了扫码登录，需要显示手机验证码登录
          if(this.code_login+this.mobile_login+this.username_login==1&&this.code_login){
            this.mobile_login = 1
          }
        }
      })
    },
    // 是否能够显示课程、直播
    getAllConfig() {
      canShowForMp().then(res => {
        console.log(res)
        const show = res.result || 0
        this.canShowMp = false// (show == 1)
      })
    },
    // 同意协议按钮
    agreeClick() {
      this.pre_type = ''
      if (this.agree) {
        this.agree = false
      } else {
        this.agree = true
      }
      sessionStorage.setItem('agree', this.agree)
    },
    // 同意协议按钮
    confirmClick() {
      console.log('同意')
      this.agree = true
      this.dialogShow = false
      sessionStorage.setItem('agree', this.agree)
      console.log(this.pre_type, ' -- pre')
      if (this.pre_type == 1 || this.pre_type == 2) {
        this.account_login(this.pre_type)
      } else if (this.pre_type == 3) {
        this.goWx()
      }
    },
    // 不同意协议按钮
    cancelDialog() {
      console.log('不同意')
      this.agree = false
      this.dialogShow = false
      sessionStorage.setItem('agree', this.agree)
    },
    // 微信登录
    goWx() {
      if (!this.agree) {
        this.pre_type = 3
        this.dialogShow = true
        return
      }
      if (this.wx_url) {
        window.location.href = this.wx_url
      } else {
        Toast({
          message: '跳转微信失败\n请使用其他方式登录',
          icon: 'close',
          className: 'noticeWidth'
        })
      }
    },
    // 获取小程序跳转链接
    getMiniUrlLink() {
      const str = this.redirect
      var share = encodeURIComponent(str)
      const info = {
        path: '/pages/login/login',
        query: `fromType=1&share=${share}`,
        env_version: 'release'
      }
      getMiniUrlLink(info).then(res => {
        console.log(res, 'res')
        if (res.result) {
          this.wx_url = res.result
        }
      })
    },
    account_login(type) {
      if (!this.agree) {
        this.pre_type = type
        this.dialogShow = true
        return
      }
      this.$router.push({
        path: 'other_login',
        query: {
          type: type,
          redirect: this.redirect,
          openid: this.openid,
          unionid: this.unionid,
          nickname: this.nickname,
          headimgurl: this.headimgurl
        }
      })
    },
    toProtocol() {
      this.$router.push({
        path: 'protocol'
      })
    }
  }
  // 温馨提示

}
</script>
<style lang='scss' scoped>
* {
  box-sizing: content-box;
}
.container {
  // width: 100%;
  // overflow: hidden;
  height: 100vh;
  display: flex;
  flex-flow: column;
  .logo{
    // margin: 356px 0 816px;
    // text-align: center;
    flex: 1;
    padding: 129px 0 0;
    img{
      display: block;
      margin: 0 auto;
    }
    .tubiaoImg{
      width: 183px;
      height: 183px;
      margin-bottom: 29px;
    }
    .textImg{
      width: 188px;
    }
    .agency_name{
      text-align: center;
      font-size: 42px;
      color:#ee2e2e;
      font-weight: 600;
    }
  }
  .foot{
    height: 480px;
    .wx_btn{
      width: 628px;
      height: 88px;
      border-radius: 10px;
      background: rgba(238, 46, 46, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 32px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      img{
        width: 48px;
        height: 48px;
        margin-right: 6px;
      }
    }
    .other{
      width: 350px;
      margin: 35px auto 0px;
      color: #999999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      .mima{
        margin-left: 16px;
      }
      .line{
        color: rgba(187, 187, 187, 1);
      }
    }
    .xy{
      color:  #999;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 35px;
      img{
        flex-shrink: 0;
        width: 35px;
        height: 35px;
        margin-right: 5px;

      }
      .icon_gray {
        opacity: 1;
      }
      .icon_red {
        opacity: 1;
        animation:animation01 0.75s;
      }
      @keyframes animation01 {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.5);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }
}
.dialog{
  /deep/.van-dialog__header{
    font-weight: 600;
    font-size: 36px;
  }
  .read{
    margin: 39px 0 52px;
    text-align: center;
    color: #999;
    font-size: 28px;
    span{
      text-decoration: underline;
    }
  }
  .btns{
    display: flex;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 96px;
    font-weight: 600;
    div{
      width: 50%;
    }
    div:first-child{
      color: #999;
    }
    div:last-child{
      color: #ee2e2e;
    }
  }
}
// /deep/.van-dialog__footer{
//   position: static;
// }
// /deep/.van-button{
//   position: static;
// }
</style>
<style>
.noticeWidth{
  width: 260px !important;
  height: 244px !important;
}
.noticeWidth .van-toast__icon{
  margin: 0 0 10px;
}
</style>
